const videoJobSelector = (
    state: sage.state.IRedux
): sage.model.IVideoJob | null => state.createAnimation.videoJob;

export default videoJobSelector;
